export default __webpack_public_path__ + "static/media/visual-basic.05f89576.svg";